// Checkbox de bloco (Seção/Subseção) com estado tri-state — cheio quando todo mundo dentro
// está marcado, parcial quando só uma parte, vazio quando nenhum. Usado em telas onde marcar
// um nó pai deve marcar/desmarcar todos os itens dentro dele (Escopo, árvore do Checklist).
export function estadoSelecao(ids, estaMarcado) {
  if (ids.length === 0) return 'vazio';
  const marcados = ids.filter(estaMarcado).length;
  if (marcados === 0) return 'vazio';
  if (marcados === ids.length) return 'cheio';
  return 'parcial';
}

export default function CheckboxCascata({ estado, onClick, title }) {
  return (
    <button type="button" className="am-checkbox" style={{ padding: 0 }} onClick={onClick} title={title}>
      <span className={`am-checkbox__box${estado !== 'vazio' ? ' is-checked' : ''}`}>
        {estado === 'cheio' && <span className="ms">check</span>}
        {estado === 'parcial' && <span className="ms">remove</span>}
      </span>
    </button>
  );
}
